package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CashRegisterConfigHeaders : TitleEnum {
    OPERATION,
    DEVICES,
    HARDWARE,
    GENERAL,
    PMS;


    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            OPERATION -> strings.operation
            DEVICES -> strings.devices
            HARDWARE -> strings.hardware
            GENERAL -> strings.general
            PMS->strings.pms
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                OPERATION -> strings.operation
                DEVICES -> strings.devices
                HARDWARE -> strings.hardware
                GENERAL -> strings.general
                PMS ->strings.pms
            }
        }
}